
export default {
    name: "LandImport",
    data() {
        return {
            pic01:require('./assets/img/001.png'),
            pic02:require('./assets/img/002.png'),
            pic03:require('./assets/img/003.png'),
            tabPosition: 'left',
            scrollHeight:250,
            url0:PLATFROM_CONFIG.baseUrl+"/fileUploadData/down/承包经营权模板.xlsx",
            url:PLATFROM_CONFIG.baseUrl+"/fileUploadData/down/土地承包数据导入.zip"
        };
    },
    created() {
    },
    methods: {
        calcTableHeight(){
          this.$nextTick(() => {
            let height = $(".content-box .content").height() - $(".content-box .content .seach-container").height() - 16 - 24 -72;
            this.scrollHeight = (height);
          });
        }
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    watch: {
        
    },
    activated: function () {
    },

    deactivated: function () {

    },
  };
